import format from 'date-fns/format';
import subDays from 'date-fns/sub_days';
import { MAGPIE_API_URI } from 'config';
import { get } from 'src/helpers/api/common';

const DEFAULT_START_DATE = format(subDays(new Date(), 30), 'YYYYMMDD');

interface MagpieRequestOptions {
  projectId: string;
  startDate: string;
  endDate: string;
}

interface EventResource {
  date: string;
  count: number;
}

interface MagpieResponse {
  EventCount: number;
  EventDay: string;
  EventId: string;
}

export async function getPageViews({
  projectId,
  startDate,
  endDate,
}: MagpieRequestOptions): Promise<EventResource[]> {
  const path = createResourceUrl({
    resource: 'pageviews',
    projectId,
    startDate,
    endDate,
  });

  const response = await get<MagpieResponse[]>(path, {
    baseUri: MAGPIE_API_URI,
    timingName: 'magpiePageViews',
    clientSideTimeout: 2000,
    withCredentials: false,
    throwOnError: false,
    withBearerAuthHeader: true,
  });

  return mapMagpieResponse(response);
}

export async function getShares({
  projectId,
  startDate,
  endDate,
}: MagpieRequestOptions): Promise<EventResource[]> {
  const path = createResourceUrl({
    resource: 'shares',
    projectId,
    startDate,
    endDate,
  });

  const response = await get<MagpieResponse[]>(path, {
    baseUri: MAGPIE_API_URI,
    timingName: 'magpieShares',
    clientSideTimeout: 2000,
    withCredentials: false,
    throwOnError: false,
    withBearerAuthHeader: true,
  });

  return mapMagpieResponse(response);
}

function mapMagpieResponse(response: MagpieResponse[] | null): EventResource[] {
  if (response) {
    return response.map(event => ({
      date: event.EventDay,
      count: event.EventCount,
    }));
  }

  return [];
}

interface CreateResourceUrlOptions {
  resource: string;
  projectId: string;
  startDate: string;
  endDate: string;
}

function createResourceUrl({
  resource,
  projectId,
  startDate = DEFAULT_START_DATE,
  endDate,
}: CreateResourceUrlOptions): string {
  const url = `/metrics/cf/${resource}/${projectId}?startDate=${startDate}`;

  return endDate ? `${url}&endDate=${endDate}` : url;
}



// WEBPACK FOOTER //
// ./src/helpers/api/magpie.ts